import { render, staticRenderFns } from "./FormTagInput.vue?vue&type=template&id=c8e05f30&"
import script from "./FormTagInput.vue?vue&type=script&lang=js&"
export * from "./FormTagInput.vue?vue&type=script&lang=js&"
import style0 from "./FormTagInput.vue?vue&type=style&index=0&id=c8e05f30&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports